<template>
  <div
    class="toast-layout"
    :style="{background:false?'none':'rgba(0, 0, 0, 0.3)'}"
    :class="{'toast-active':visible}"
  >
    <div class="toast-con recharge-con" :style="{minWidth:'868px'}">
      <div class="t-header">
        <span>点数充值</span>
        <i class="iconfont icon-cuowu" @click="handleClick"></i>
      </div>
      <div class="pay-con">
        <div class="device">
          <div class="attr">开通设备：</div>
          <div class="val">{{pointchildName}}</div>
        </div>
        <div class="capacity">
          <div class="attr">选择容量：</div>
          <div class="val">
            <div class="tag tag-active">
              <span class="year">{{activeItem.capacity}}</span>
              <span class="price">
                <i style="font-size:12px">￥</i>{{activeItem.price}}
                <span class="per">元</span>
              </span>
              <img :src="`${$cdn}images/tag-icon.png`" alt />
            </div>
          </div>
        </div>
        <div class="mid">
          <div class="attr">支付方式：</div>
          <div class="body">
            <div
              class="pay-tag"
              :class="{'tag-active':paytype==='alipay'}"
              @click="paytype='alipay'"
              v-if="langauge!=='en'"
            >
              <img :src="`${$cdn}images/ali-pay.png`" class="t-icon" alt />
              <span>支付宝</span>
              <img :src="`${$cdn}images/tag-icon.png`" class="t-click" alt />
            </div>
            <div
              class="pay-tag"
              :class="{'tag-active':paytype==='wechatPay'}"
              @click="paytype='wechatPay'"
              v-if="langauge!=='en'"
            >
              <img :src="`${$cdn}images/wechat-pay.png`" class="t-icon" alt />
              <span>微信支付</span>
              <img :src="`${$cdn}images/tag-icon.png`" class="t-click" alt />
            </div>
            <div
              class="pay-tag paypal-con"
              :class="{'tag-active':paytype==='paypal'}"
              @click="paytype='paypal'"
              v-if="langauge==='en'"
            >
              <img :src="`${$cdn}images/paypal.png`" class="t-icon" alt />
              <span>paypal</span>
              <img :src="`${$cdn}images/tag-icon.png`" class="t-click" alt />
              <form
                class="form-con"
                method="post"
                :action="`api/order/pay/paypal`"
              >
                <input v-model="currentId" type="text" name="orderId" />
                <input v-model="currentType" type="text" name="orderType" />
                <input type="submit" value="提交" />
              </form>
            </div>
          </div>
        </div>
        <div class="amount"  v-if="paytype !== 'paypal'">
          <div class="attr">应付金额：</div>
          <div class="val">
            <p class="a-price">￥{{activeItem.price}}</p>
            <img class="price-img" :src="response.src" alt="">
            <img class="scanicon" :src="`${$cdn}images/scanicon.png`" alt="">
            <div class="dec">
              使用
              <span style="color:#ff0000">{{payZH}}</span>app扫码完成支付
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

let payTypes = {
  wechatPay: '微信',
  alipay: '支付宝',
  paypal: 'paypal'
}

let PAYSID = {
  'wechatPay': 0,
  'alipay': 1,
  'paypal': 2
}

let PAYSSTR = {
  0: 'wechatPay',
  1: 'alipay',
  2: 'paypal'
}

export default {
  props: ['visible', 'pointitem', 'pointid', 'pointchildName'],
  computed: {
    payZH () {
      return payTypes[this.paytype]
    }
  },
  data () {
    let pointType = [
      {
        capacity: '600点',
        price: '600'
      },
      {
        capacity: '800点',
        price: '800'
      },
      {
        capacity: '1000点',
        price: '1000'
      }
    ]
    return {
      privilege: 'year',
      response: '',
      t1: null,
      paytype: 'wechatPay',
      pointType,
      activeItem: '',
      currentId: '',
      currentType: 1,
      langauge: localStorage.getItem('language')
    }
  },
  watch: {
    visible (newVal) {
      this.langauge = localStorage.getItem('language')

      if (newVal) {
        this.pointType.forEach(item => {
          if (item.capacity === this.pointitem.capacity) {
            this.activeItem = this.pointitem
          }
        })
        this.pay()
      } else {
        clearInterval(this.t1)
        this.t1 = null
      }
    },
    activeItem () {
      this.pay()
    },
    paytype () {
      this.pay()
    }
  },
  methods: {
    handleClick () {
      this.$emit('closePoint')
    },
    inverRequest () {
      clearInterval(this.t1)
      this.t1 = null
      this.t1 = setInterval(() => {
        this.queryOrderStatus()
      }, 5000)
    },
    async queryOrderStatus () {
      if (this.t1) {
        let params = {
          orderSn: this.orderSn,
          orderType: 1,
          payType: PAYSID[this.paytype]
        }
        let res = await this.$http
          .post('/user/order/queryOrderStatus', params, {
            headers: {
              token: localStorage.getItem('token')
            }
          })
        let response = res.data
        if (response.code === 0 && response.data) {
          this.t1 = null
          this.t1 && clearInterval(this.t1)

          this.$emit('closePoint', true)
        }
      }
    },
    async pay () {
      let {price} = this.activeItem

      let params = {
        cameraId: this.pointid,
        points: price,
        payType: PAYSID[this.paytype],
        abroad: localStorage.getItem('language') === 'en' ? 1 : 0
      }

      let res = await this.$http
        .post('/user/order/rechargeOrder', params, {
          headers: {
            token: localStorage.getItem('token')
          }
        })

      let data = res.data
      if (data.code !== 0) {
        return this.$toast.show('error', `获取订单信息失败，${data.msg}`)
      }
      let {id, payType, orderSn} = data.data
      this.currentId = id
      this.orderSn = orderSn
      this.getCode(id, payType)
    },
    async getCode (id, payType) {
      if (payType !== 2) {
        let params = {
          orderId: id,
          orderType: 1
        }
        let res = await this.$http
          .post(`/order/pay/${PAYSSTR[payType]}`, params, {
            headers: {
              token: localStorage.getItem('token')
            }
          })
        let response = res.data
        if (response.code !== 0) {
          return this.$toast.show('error', '获取支付二维码失败', () => {
            this.t1 = null
            this.t1 && clearInterval(this.t1)
          })
        }
        this.response = response.data
        this.inverRequest()
      } else {
        this.t1 = null
        this.t1 && clearInterval(this.t1)
        this.$toast.show('warn', '正在跳转至paypal支付链接，请稍等')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/components/toast/pointRecharge.vue